function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 14.8,
  rx: 4,
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 14.8,
  rx: 4,
  fill: "#41479B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10h20v1a4 4 0 01-4 4H4a4 4 0 01-4-4v-1z",
  fill: "#FF4B55"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4a4 4 0 014-4h12a4 4 0 014 4v1H0V4z",
  fill: "#F5F5F5"
});

function SvgColoredRuFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgColoredRuFlag;